<template>
  <CustomButton :to="{ name: 'customPropertiesList' }" label="Links.goBack" />
  <p class="page-title">Création de propriété personnalisée</p>
  <div class="form-container">
    <FormKit
      type="form"
      @submit="submitHandler"
      :actions="false"
      incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
    >
      <FormKit
        type="text"
        name="name"
        label="Propriété"
        placeholder="Entrer un nom de propriété"
        validation="required|length:1,50"
        :validation-messages="{
                required: 'Ce champ est obligatoire.',
                length: 'Ce champ doit contenir maximum 50 caractères.',
                }"
      />

      <FormKit
        id="repeater"
        v-model="specialProperties"
        name="values"
        type="repeater"
        label="Valeurs de la propriété"
        #default="{ index }"
        add-label="Ajouter une valeur"
        min="1"
      >
        <FormKit
          type="text"
          :label="`${index + 1}. Valeur`"
          name="value"
          validation="required|length:1,50|checkDuplicateName"
          :validation-rules="{checkDuplicateName}"
          placeholder="Entrer une valeur"
          :validation-messages="{
                required: 'Ce champ est obligatoire.',
                length: 'Ce champ doit contenir maximum 50 caractères.',
                checkDuplicateName:'Cette valeur existe déjà.'
                }"
        />
      </FormKit>
      <FormKit
        type="submit"
        label="Céer"
      />
    </FormKit>
  </div>
</template>
<script setup lang="ts">
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import router from "@/router";
import {ref} from "vue";
import CustomButton from "@/components/forms/CustomButton.vue";

const  specialProperties = ref();
function checkDuplicateName(node){
  return specialProperties.value.filter((property) => property.value.toLowerCase() === node.value.toLowerCase()).length === 1
}
function submitHandler(data, formNode) {
  return ApiService.post("/properties", data)
    .then(({data}) => {
      swal.success("Propriété créée !", "");
      router.push({ name: 'customPropertiesList' });
    })
    .catch(({response}) => {
      response.data.errors.forEach((error) => {
        let field = error.property;
        if (field) {
          field = field.replace('[', '.');
          field = field.replace(']', '');
          formNode.setErrors(
            null,
            {
              [field]: error.message
            }
          );
        }
        return false;
      });
    });
}
</script>

